import { graphqlClient } from "../../../client";
import mutationDocument from "./createOrderFromQuoteWithPaymentAuthorizationMutation.graphql";
import type {
  CreateOrderFromQuoteWithPaymentAuthorizationMutation,
  KeyValueType,
  MutationsCreateOrderFromQuoteWithPaymentAuthorizationArgs,
} from "@/core/api/graphql/types";

export async function createOrderFromQuoteWithPaymentAuthorization(
  quoteId?: string,
  parameters?: KeyValueType[],
): Promise<CreateOrderFromQuoteWithPaymentAuthorizationMutation["createOrderFromQuoteWithPaymentAuthorization"]> {
  const { data } = await graphqlClient.mutate<
    CreateOrderFromQuoteWithPaymentAuthorizationMutation,
    MutationsCreateOrderFromQuoteWithPaymentAuthorizationArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        id: quoteId,
        parameters,
        storefrontUrl: location.origin,
      },
    },
  });

  return data?.createOrderFromQuoteWithPaymentAuthorization;
}
